import { render, staticRenderFns } from "./CreateAcademicRank.vue?vue&type=template&id=7b0f9830&"
import script from "./CreateAcademicRank.vue?vue&type=script&lang=js&"
export * from "./CreateAcademicRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports